import { Routes } from '@angular/router';

export const routes: Routes = [

  {
    path: '',
    loadComponent: () =>
      import('./features/public/home-public/home-public')
      .then(m => m.HomePublic)
  },

  {
    path: 'administracion',
    loadComponent: () =>
      import('./features/auth/admin-login/admin-login')
      .then(m => m.AdminLogin)
  },

  {
    path: 'tiendas',
    loadComponent: () =>
      import('./features/auth/business-login/business-login')
      .then(m => m.BusinessLogin)
  },

  {
    path:'**',
    redirectTo:''
  }

];